// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2TX2Z","col":"styles_col__EHHU6","fulfillmentStatus":"styles_fulfillmentStatus__eXKaO","emailCol":"styles_emailCol__1utkP"};